document.addEventListener('DOMContentLoaded', () => {
   $('#shopify-section-template--23874678489391__rich_text_7X3RUb .rich-text__blocks').slick({
  centerMode: true,
  arrows: false,
  infinite: true,
  dots: false,
  fade: true,
  speed: 3000,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToScroll: 1,
  slidesToShow: 1
});

   });